import styled from 'styled-components'

import { Icon } from '../../../components/Icons'
import { Text } from '../../../components/Text'
import { Tooltip } from '../../../components/Tooltip'

const PortfolioLabelTextWrapper = styled.span`
  margin-inline-start: 10px;
`

type PortfolioLabelProps = {
  inPortfolio: boolean
}

export const PortfolioLabel = ({ inPortfolio }: PortfolioLabelProps) => (
  <Tooltip
    placement="right"
    title={'The company will be automatically added to the portfolio when "Planned revision" is bought.'}
    trigger={['click', 'hover']}
    color="pumpkinOrange"
  >
    <span>
      <Text color={inPortfolio ? 'primary' : 'orange'} fontSize="16px" display="flex" alignContent="center">
        <Icon type={inPortfolio ? 'CaseBlue' : 'CaseOrange'} />
        <PortfolioLabelTextWrapper>{inPortfolio ? 'In portfolio' : 'Not in portfolio'}</PortfolioLabelTextWrapper>
      </Text>
    </span>
  </Tooltip>
)
